import { Box, Button, Typography } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Step2 = ({ sra, setSra, setStep, storedUser }) => {
  const [btnLoading, setBtnLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const handleChange = (e) => {
    setSra({ ...sra, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const validateForm = () => {
    const newErrors = {};
    const data = sra || {};

    const isEmpty = (value) => !value || value.trim?.() === "";

    if (isEmpty(data.justification)) {
      newErrors.justification = "Recommendation is required";
    } else if (data.justification.length > 1000) {
      newErrors.justification =
        "Recommendation should be up to 1000 characters";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleUpdate = async () => {
    if (!validateForm()) return;
    setBtnLoading(true);
    try {
      setStep((prev) => prev + 1);
    } catch (error) {
      console.log(error);
    } finally {
      setBtnLoading(false);
    }
  };

  const handleBack = () => {
    setStep((prev) => prev - 1);
  };

  return (
    <div style={{ position: "relative" }}>
      {btnLoading && <div className="loading-div"></div>}
      <h2>Service Order Approval Form</h2>
      <div className="progress-container">
        <span className="blue-bar" style={{ width: "40%" }}></span>
      </div>
      <div className="dashboard-container">
        <Box>
          <Typography className="form-title">Justification</Typography>
          <label htmlFor="justification">
            Recommended Vendor and Reason for Recommendation{" "}
            <span style={{ color: "#FF0000" }}>*</span>
          </label>
          <textarea
            className={`${errors.justification && "input-error"}`}
            name="justification"
            id="justification"
            rows={8}
            value={sra && sra.justification}
            onChange={handleChange}
            maxLength={1000}
          ></textarea>
          {errors.justification && (
            <p className="error">{errors.justification}</p>
          )}
        </Box>
      </div>
      <Box className="btn-container" sx={{ gap: 3 }}>
        <Button className="btn-outlined" onClick={handleBack}>
          Back
        </Button>
        <Button
          className="btn-contained"
          onClick={handleUpdate}
          disabled={btnLoading}
        >
          {btnLoading ? "Submitting..." : "Next"}
        </Button>
      </Box>
    </div>
  );
};

export default Step2;
